import { isStrategy } from '@tradingblock/types';
import { CallCalendar, PutCalendar } from '..';
export var isCalendar = function isCalendar(strategy) {
  return isStrategy([CallCalendar, PutCalendar], strategy);
};